var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "48px_apple-2",
    clipPath: "url(#clip0_18_1115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1602 8.48523C18.5093 6.35269 15.5269 7.8894 13 7.8894C10.4732 7.8894 7.49074 6.35431 4.83983 8.48523C2.4072 10.4406 1.60012 16.3768 4.88099 21.6228C8.02916 26.656 11.2039 24.9497 13 24.9497C14.7962 24.9497 17.9709 26.656 21.1191 21.6228C24.4 16.3768 23.5929 10.4406 21.1602 8.48523Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.4167 0.853149V1.93648C18.4167 2.9421 18.0172 3.90652 17.3062 4.6176C16.5951 5.32867 15.6307 5.72815 14.6251 5.72815V5.72815V4.64482C14.6251 3.6392 15.0245 2.67478 15.7356 1.9637C16.4467 1.25263 17.4111 0.853149 18.4167 0.853149V0.853149Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13 7.89482C13 5.72815 11.4655 3.15523 9.20837 2.47815",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_1115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(6.10352e-05 0.853149)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.3f17aa0a03a64e67dec791f5505d3b09.svg";
export { ForwardRef as ReactComponent };